var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep11To8Mobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 274,
    viewBox: "0 0 106 274",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.584 3.64645C32.3887 3.8417 32.3887 4.15829 32.584 4.35354L35.7659 7.53552C35.9612 7.7308 36.2778 7.7308 36.473 7.53552C36.6683 7.34027 36.6683 7.02368 36.473 6.82842L33.6446 3.99999L36.473 1.17156C36.6683 0.976312 36.6683 0.659723 36.473 0.464472C36.2778 0.26919 35.9612 0.26919 35.7659 0.464471L32.584 3.64645ZM-1.52996e-05 273.5L85 273.5L85 272.5L-1.5218e-05 272.5L-1.52996e-05 273.5ZM105.5 253L105.5 24L104.5 24L104.5 253L105.5 253ZM85 3.5L32.9375 3.49999L32.9375 4.49999L85 4.5L85 3.5ZM105.5 24C105.5 12.6782 96.3218 3.5 85 3.5L85 4.5C95.7696 4.5 104.5 13.2304 104.5 24L105.5 24ZM85 273.5C96.3218 273.5 105.5 264.322 105.5 253L104.5 253C104.5 263.769 95.7696 272.5 85 272.5L85 273.5Z",
    fill: "#134046"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep11To8Mobile);
export default __webpack_public_path__ + "static/media/step_11_to_8_mobile.e5fe5bd868703b981623c013dc72d9f2.svg";
export { ForwardRef as ReactComponent };